import { render } from "./PaymentInfo.vue?vue&type=template&id=48850662&scoped=true"
import script from "./PaymentInfo.vue?vue&type=script&lang=js"
export * from "./PaymentInfo.vue?vue&type=script&lang=js"

import "./PaymentInfo.vue?vue&type=style&index=0&id=48850662&scoped=true&lang=scss"

import exportComponent from "C:\\flexites\\1lombard\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48850662"]])

export default __exports__